import React from 'react';

import cs from 'classnames';
import { FieldValues, useFormContext } from 'react-hook-form';

import { Select } from 'components/shared/Select/adapters/HookForm';
import Text from 'components/shared/Typography/Text';

import sharedStyles from '../../../../shared/index.module.css';

type Props = {
  onClickOneOff: () => void;
  withoutOneOff?: boolean;
  disabled?: boolean;
  options: FieldValues[];
};

function PageTypeForm({ onClickOneOff, disabled, options, withoutOneOff }: Props) {
  const { control } = useFormContext();
  const isSingleOption = options.length <= 1;

  return (
    <>
      {!withoutOneOff && (
        <div className={sharedStyles.descriptionContainer}>
          <Text type="brandon" className={sharedStyles.commonText}>
            Don’t want to save as re-usable content?
          </Text>
          <Text type="brandon" size="medium" className={cs('link', sharedStyles.cssLink)} onClick={onClickOneOff}>
            Click to use as one-off placeholder event
          </Text>
        </div>
      )}

      <div className={sharedStyles.selectorContainer}>
        <Select
          name="type"
          control={control}
          label={() => 'Page Type*'}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          optionToString
          options={options}
          isDisabled={disabled || isSingleOption}
          blurInputOnSelect
        />
      </div>
    </>
  );
}

export { PageTypeForm };
